module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/services.json
// module id = 670
// module chunks = 257431895517821